import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';

import {
  Typography, Checkbox, Box
} from '@mui/material';

const ContactsTable = ({ contactType = 'operators', initialData }) => {
  const dispatch = useDispatch();
  const debouncedDispatch = useRef();

  const {
    contacts
  } = useSelector(state => state.fpzReducer);
  
  const [data, setData] = useState(initialData);
  console.log('ContactsTable data', data);

  const handleInputChange = (operatorIndex, contactIndex, field, value) => {
    setData(prev => {
      const newData = [...prev];
      newData[operatorIndex].contacts[contactIndex][field] = value;
      return [...newData];
    });
  };

  const handleAddRow = (operatorIndex) => {
    setData(prev => {
      const newData = [...prev];
      newData[operatorIndex].contacts.push({ name: "", email: "", phone: "", designation: "" });
      return newData;
    });
  };

  const handleRemoveRow = (operatorIndex, contactIndex) => {
    setData(prev => {
      const newData = [...prev];
      if (newData[operatorIndex].contacts.length > 1) {
        newData[operatorIndex].contacts.splice(contactIndex, 1);
      }
      return newData;
    });
  };

  useEffect(() => {
    debouncedDispatch.current = debounce((newData) => {
      dispatch({
        type: "SET_FPZ_CONTACTS",
        payload: { ...contacts, [contactType]: newData }
      });
    }, 500);

    return () => {
      debouncedDispatch.current.cancel(); // cleanup on unmount or change
    };
  }, [contacts, contactType, dispatch]);

  useEffect(() => {
    if (data && debouncedDispatch.current) {
      debouncedDispatch.current(data);
    }
  }, [data]);
  
  return (
    <div>
      {data.map((op, operatorIndex) => (
        <div key={op.operator} style={{ marginBottom: "2rem" }}>
          <Typography variant="subtitle1" gutterBottom>{op.operator}</Typography>
          <table border="1" cellPadding="6" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Designation</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {op.contacts.map((contact, contactIndex) => {
                const isLast = contactIndex === op.contacts.length - 1;
                return (
                  <tr key={contactIndex}>
                    {["name", "email", "phone", "designation"].map(field => (
                      <td key={field}>
                        <input
                          type="text"
                          value={contact[field]}
                          onChange={(e) =>
                            handleInputChange(operatorIndex, contactIndex, field, e.target.value)
                          }
                        />
                      </td>
                    ))}
                    <td>
                      {isLast ? (
                        <button onClick={() => handleAddRow(operatorIndex)}>+</button>
                      ) : (
                        <button onClick={() => handleRemoveRow(operatorIndex, contactIndex)}>-</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default ContactsTable;
